import * as yup from "yup";
export const createUserSchema = yup.object({
  email: yup.string().email("Invalid email format").required("Required"),
  firstName: yup.string().required("required"),
  lastName: yup.string().required("required"),
  organization: yup.string().required("required"),
  userType: yup.string().required("required"),
});
